module.exports = __webpack_public_path__ + "static/Metrc@2x-9e0b7fb4a7c10a7cfe3272ba4833a8a6.png";